import { StanDropdownMenu } from '@/components';
import { DropdownProvider } from '@/components/core-components/StanDropdown/DropdownProvider';
import type { DropdownMenuOption, DropdownValue } from '@/components/core-components/StanDropdown/StanDropdown.types';
import { PageStatus } from '@/types/store';
import IcHidden from '@/assets/icons/ic-hidden.svg';
import IcDuplicate from '@/assets/icons/ic-duplicate.svg';
import IcTrash from '@/assets/icons/ic-trash.svg';
import IcMoreVertical from '@/assets/icons/ic-more-vertical.svg';

interface FunnelPageActionsMenuProps {
    pageId: number;
    pageStatus: number;
    pageType: string;
    onHide?: () => void;
    onDuplicate: () => void;
    onDelete: () => void;
}

export const FunnelPageActionsMenu = ({
    pageId,
    pageStatus,
    pageType,
    onHide,
    onDuplicate,
    onDelete,
}: FunnelPageActionsMenuProps) => {
    const options: DropdownMenuOption[] = [
        ...(pageStatus === PageStatus.PUBLISHED && onHide
            ? [
                  {
                      label: 'Hide Page',
                      value: 'hide',
                      icon: IcHidden,
                  },
              ]
            : []),
        ...(pageType !== 'community'
            ? [
                  {
                      label: 'Duplicate Page',
                      value: 'duplicate',
                      icon: IcDuplicate,
                  },
              ]
            : []),
        {
            label: 'Delete Page',
            value: 'delete',
            icon: IcTrash,
            type: 'destructive' as const,
        },
    ];

    const handleSelect = (_value: DropdownValue, option: DropdownMenuOption) => {
        switch (option.value) {
            case 'hide':
                onHide?.();
                break;
            case 'duplicate':
                onDuplicate();
                break;
            case 'delete':
                onDelete();
                break;
        }
    };

    return (
        <DropdownProvider dropdownId={`funnel-page-actions-${pageId}`} dropdownName={`funnel-page-actions-${pageId}`}>
            <StanDropdownMenu
                id={`funnel-page-actions-${pageId}`}
                name={`funnel-page-actions-${pageId}`}
                options={options}
                onSelect={handleSelect}
                placement='bottom-end'
                minWidth={180}
            >
                <IcMoreVertical className='text-semantic-fg-muted size-5' />
            </StanDropdownMenu>
        </DropdownProvider>
    );
};
